import React from "react";
import { getFormatOraInput } from "../../utils/dateFormat";
import { Button } from "react-bootstrap";
import { loadingWrapper } from "../../utils/loadingWrapper";
import CustomTable from "../../components/custom-table/CustomTable";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faMagnifyingGlass, faPlus } from "@fortawesome/free-solid-svg-icons";
//todo import and change this -- > import CreateTicket from "../../components/modals/create-ticket/CreateTicket";
import useTicket from "../../hooks/useTicket";
import { toast } from "react-toastify";
import { useNavigate, withRouter } from "react-router-dom";
import Menucustom from "../../common/menu/menucustom";
import CreateTicketWrapper from "../../components/modals/create-ticket/CreateTicket";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
class DashboardTicket extends React.Component {
    headerDataTable = [
        { label: "Oggetto", field: "oggetto", width: 270 },
        { label: "Categoria", field: "categoria", width: 270 },
        { label: "Descrizione", field: "descrizione", width: 270 },
    ];

    state = {
        dataTable:  [],
        ticketListAll: [],
        filter: {
            startDate: getFormatOraInput(new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)),
            endDate: getFormatOraInput(new Date()),
            state: "ALL",
        },
        showCreateModal: false,
    };

    componentDidMount() {
        this.searchTicket();
    }

    showCreateModalHandle = () => {
        this.setState((prevState) => ({
            ...prevState,
            showCreateModal: !prevState.showCreateModal,
        }));
    }

    searchTicket = () => {
        const { getTicketList } = this.props;
        const { filter } = this.state;

        getTicketList(
            {
                state: filter.state,
                startDate: new Date(new Date(filter.startDate).setHours(0, 0, 0)).getTime(),
                endDate: new Date(new Date(filter.endDate).setHours(23, 59, 59)).getTime(),
            },
            (response) => {
                // TODO: Da modificare dispatch(setTicketList(response));
                this.setState({ ticketListAll: response });
                this.setupDatatable(response);
            },
            () => {
                toast.error("Errore nel recupero dei ticket");
            }
        );
    };

    setupDatatable = (data) => {
        const parsedData = JSON.parse(JSON.stringify(data));
        parsedData.forEach((ticket, index) => {
            //   ticket.dataCreazione = getDataFormat(new Date(ticket.dataCreazione), "dd/MM/yyyy");
            ticket.clickEvent = () => {
                this.selectTicket(data[index]);
                //this.onRowClick(ticket);
            };
        });

        this.setState((prevState) => ({
            ...prevState,
            dataTable: parsedData,
        }));
    };

    selectTicket = (ticket) => {
        sessionStorage.setItem("selectedTicket",JSON.stringify(ticket));
        window.location.href="#/ticketDetail"
    };

    onChangeFilter = (event) => {
        const { name, value } = event.target;
        this.setState((prevState) => ({
            ...prevState,
            filter: { ...prevState.filter, [name]: value },
        }));
    };

    openCreateModal = () => {
        this.showCreateModalHandle();
        // TODO: Da modificare dispatch(setShowCreateTicket());
    };

    onRowClick = (row) => {
        //const { navigate } = this.props;
        // TODO: Da modificare dispatch(setSelectedTicket(row));
        //this.props.history.push("/ticketDetail")
        //navigate("/ticketDetail");
    };

    render() {
        const { loadingTicket } = this.props;
        const { dataTable, filter, showCreateModal } = this.state;

        return (
            <>
            <div id="wrapper">
                <Menucustom/>
                <div className="container-fluid">
                    <div className="row p-3">
                        <div className="d-flex align-items-center justify-content-between mb-4 px-1">
                            <div>
                                <h1 className="h1 mb-0 text-gray-800">Dashboard Ticket</h1>
                            </div>
                            <div className="d-flex gap-2 ">
                                <Button variant="warning" onClick={() => this.openCreateModal()} className="text-white">
                                    <FontAwesomeIcon icon={faPlus} className="text-white"/>
                                    {/* <FontAwesomeIcon icon={faPlus} /> */}
                                </Button>
                            </div>
                        </div>

                        <div className="row align-items-end">
                            <div className="col-8 mb-1">
                                <fieldset className="detail-fieldset w-100 bg-transparent">
                                    <legend className="detail-legend">Data apertura ticket</legend>
                                    <div className="d-flex flex-row gap-3 w-100">
                                        <div className="d-flex flex-column flex-grow-1">
                                            <p className="m-0">Da:</p>
                                            <input
                                                type="date"
                                                name="startDate"
                                                value={filter.startDate}
                                                max={getFormatOraInput(new Date(filter.endDate))}
                                                onChange={this.onChangeFilter}
                                                className="form-control"
                                            />
                                        </div>

                                        <div className="d-flex flex-column flex-grow-1">
                                            <p className="m-0">A:</p>
                                            <input
                                                type="date"
                                                name="endDate"
                                                value={filter.endDate}
                                                min={getFormatOraInput(new Date(filter.startDate))}
                                                max={getFormatOraInput(new Date())}
                                                onChange={this.onChangeFilter}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div className="col-3 mb-4">
                                <div className="d-flex flex-column w-100">
                                    <label>Stato:</label>
                                    <select
                                        className="form-select"
                                        onChange={this.onChangeFilter}
                                        value={filter.state}
                                        name="state"
                                    >
                                        <option value={"ALL"}>Tutti gli stati</option>
                                        <option value="APERTO">Aperto</option>
                                        <option value="IN_LAVORAZIONE">In lavorazione</option>
                                        <option value="CHIUSO">Chiuso</option>
                                    </select>
                                </div>
                            </div>
                            <div className='col-1 mb-4'>
                                <Button className='btn' onClick={this.searchTicket} variant='warning'>
                                    {loadingWrapper(loadingTicket, <>Cerca</>)}
                                </Button>
                            </div>
                        </div>
                        <CustomTable header={this.headerDataTable} data={dataTable}  label='Ticket'/>
                        {showCreateModal && <CreateTicketWrapper onSuccess={this.searchTicket} show={showCreateModal} onClose={this.showCreateModalHandle}/>}
                    </div>
                </div>
            </div>
                
            </>
        );
    }
}

const DashboardTicketWrapper = () => {
    const { getTicketList, loadingTicket } = useTicket();

    return (
        <DashboardTicket
            getTicketList={getTicketList}
            loadingTicket={loadingTicket}
        />
    );
};

export default withRouter(DashboardTicketWrapper);
